import React, { ReactNode, useContext, useEffect, useState } from 'react';

import TicketConfigurationContext from '@totem/components/ticketing/configuration/ticketingConfigurationContext';
import { filterCategories } from '@totem/components/ticketing/permissions';
import {
  TicketCategory,
  TicketTypeConfig,
} from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  children?: ReactNode;
};
const TicketingConfigurationContainer = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [ticketTypes, setTicketTypes] = useState<TicketTypeConfig[]>([]);
  const [categories, setCategories] = useState<TicketCategory[]>([]);
  const [filteredCategories, setFilteredCategories] = useState<
    TicketCategory[]
  >([]);
  const [refresh, setRefresh] = useState<boolean>(true);
  useEffect(() => {
    setRefresh(true);
  }, [userProfile.organization.id]);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);

      fetch(`${TICKET_ENDPOINT}/ticketTypes`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: TicketTypeConfig[]) => {
          setTicketTypes(result);
        });
    }
  }, [refresh, userProfile.organization.id]);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);

      fetch(`${TICKET_ENDPOINT}/categoriesByType`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: TicketCategory[]) => {
          setCategories(result);
          const tmpFilteredCategories = filterCategories(
            userProfile,
            result,
            null,
          );
          setFilteredCategories(tmpFilteredCategories);
        });
    }
  }, [refresh, userProfile.organization.id]);

  return (
    <TicketConfigurationContext.Provider
      value={{ ticketTypes, categories, filteredCategories }}
    >
      {children}
    </TicketConfigurationContext.Provider>
  );
};
export default TicketingConfigurationContainer;
